// @ts-expect-error file untyped
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { getProjectedTotalTooltipMessage } from './getProjectedTotalMessage';
import emptyFunction from 'react-utils/emptyFunction';
import { useProperty } from 'crm-object-board-core/properties';
import { useGetCurrencyFormatting } from 'crm-object-board-core/multiCurrency';
import { AGG } from 'crm-pipeline-board-settings-lib/aggregations/types/Aggregations';
import { useStagesWithReconciledObjects } from '../../../reconciliation/useStagesWithReconciledObjects';
import { useObjectTypeId } from 'crm-object-board-core/objectTypeDefinition';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEAL_STAGE_PROBABILITY_PROPERTY_NAME = 'hs_deal_stage_probability';
const KB_URL = 'https://knowledge.hubspot.com/crm-setup/manage-records-in-board-view#move-records-between-pipeline-stages';
const alwaysUndefined = emptyFunction.thatReturns(undefined);
const getCurrencyTotal = aggregation => {
  if (!aggregation) {
    return null;
  }
  return aggregation.value;
};
const AmountTooltipText = ({
  aggregation,
  metadata,
  config,
  totalCards,
  stageId
}) => {
  const objectTypeId = useObjectTypeId();
  const getCurrencyFormatting = useGetCurrencyFormatting();
  const homeCurrencyProperty = useProperty(config.property);
  const dealStageProbabilityProperty = useProperty(DEAL_STAGE_PROBABILITY_PROPERTY_NAME);
  const agg = aggregation;
  const currencyTotal = getCurrencyTotal(agg) || 0;
  const isAverage = config.aggregation === AGG.AVG;
  const probability = metadata && metadata.probability || '0';
  const isProjected = config.meta.projected;
  const stages = useStagesWithReconciledObjects();
  const stageHasReconciledRecords = Boolean(stages.has(stageId));
  if (isProjected && dealStageProbabilityProperty && homeCurrencyProperty) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Text, {
        as: "div",
        typography: "body-100",
        marginInlineEnd: "1300",
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: getProjectedTotalTooltipMessage(probability),
          options: {
            probability: /*#__PURE__*/_jsx(FormattedPropertyV2, {
              objectTypeId: objectTypeId,
              objectId: undefined,
              property: dealStageProbabilityProperty,
              value: String(probability),
              getDraftValue: alwaysUndefined,
              getSavedValue: alwaysUndefined
            })
          }
        }), stageHasReconciledRecords && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "crmObjectBoard.deals.projectedTotal.reconciledDelay_jsx",
              elements: {
                Link: KnowledgeBaseButton
              },
              options: {
                url: KB_URL
              }
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(Text, {
        as: "div",
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
          objectTypeId: objectTypeId,
          objectId: undefined,
          property: homeCurrencyProperty,
          value: String(currencyTotal),
          getDraftValue: alwaysUndefined,
          getSavedValue: alwaysUndefined,
          currencyProps: Object.assign({}, getCurrencyFormatting(currencyTotal), {
            simplifyCurrency: false
          })
        })
      })]
    });
  }
  if (isAverage && homeCurrencyProperty) {
    const average = currencyTotal / (totalCards || 1);
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "div",
        typography: "body-100",
        marginInlineEnd: "1300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoard.deals.averageLabel"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "div",
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
          objectTypeId: objectTypeId,
          objectId: undefined,
          property: homeCurrencyProperty,
          value: String(average),
          getDraftValue: alwaysUndefined,
          getSavedValue: alwaysUndefined,
          currencyProps: Object.assign({}, getCurrencyFormatting(average), {
            simplifyCurrency: false
          })
        })
      })]
    });
  }
  if (homeCurrencyProperty) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "div",
        typography: "body-100",
        marginInlineEnd: "1300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoard.deals.totalLabel"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "div",
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedPropertyV2, {
          objectTypeId: objectTypeId,
          objectId: undefined,
          property: homeCurrencyProperty,
          value: String(currencyTotal),
          getDraftValue: alwaysUndefined,
          getSavedValue: alwaysUndefined,
          currencyProps: Object.assign({}, getCurrencyFormatting(currencyTotal), {
            simplifyCurrency: false
          })
        })
      })]
    });
  }
  return null;
};
export default AmountTooltipText;